<script setup>
import { REPLY_EDITOR_MODES } from './constants';

// Swissöra · fil unique: la riga unica del composer — WhatsApp | Email | Note privée.
// Il canale è il TARGET di invio: la conversazione visibile non cambia mai.
const props = defineProps({
  mode: {
    type: String,
    default: REPLY_EDITOR_MODES.REPLY,
  },
  channel: {
    type: String,
    default: null, // 'whatsapp' | 'email'
  },
  canWhatsapp: {
    type: Boolean,
    default: false,
  },
  canEmail: {
    type: Boolean,
    default: false,
  },
  windowLabel: {
    type: String,
    default: null, // es. '23h13' oppure 'fermée · template'
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['setChannel', 'setNote']);

const isNote = () => props.mode === REPLY_EDITOR_MODES.NOTE;

const segClass = (active, enabled = true) => {
  if (!enabled) return 'text-n-slate-10 opacity-50 cursor-not-allowed';
  return active
    ? 'bg-n-solid-1 shadow-sm text-n-slate-12 font-medium'
    : 'text-n-slate-11 hover:text-n-slate-12';
};

const onChannel = ch => {
  if (props.disabled) return;
  if (ch === 'whatsapp' && !props.canWhatsapp) return;
  if (ch === 'email' && !props.canEmail) return;
  emit('setChannel', ch);
};
</script>

<template>
  <div class="flex items-center gap-3 min-w-0" data-sw-native="true">
    <div
      class="flex items-center flex-shrink-0 h-8 p-1 border rounded-full border-n-weak bg-n-alpha-2"
    >
      <button
        class="flex items-center gap-1.5 h-6 px-3 text-sm rounded-full whitespace-nowrap transition-colors duration-150"
        :class="segClass(!isNote() && channel === 'whatsapp', canWhatsapp)"
        :title="!canWhatsapp ? 'pas de téléphone sur ce contact' : ''"
        @click="onChannel('whatsapp')"
      >
        <span
          class="inline-block size-1.5 rounded-full flex-shrink-0 bg-[#25D366]"
          :class="{ 'opacity-40': canWhatsapp && (isNote() || channel !== 'whatsapp') }"
        />
        WhatsApp
      </button>
      <button
        class="flex items-center gap-1.5 h-6 px-3 text-sm rounded-full whitespace-nowrap transition-colors duration-150"
        :class="segClass(!isNote() && channel === 'email', canEmail)"
        :title="!canEmail ? 'pas d’email sur ce contact' : ''"
        @click="onChannel('email')"
      >
        <span
          class="inline-block size-1.5 rounded-full flex-shrink-0 bg-[#60a5fa]"
          :class="{ 'opacity-40': canEmail && (isNote() || channel !== 'email') }"
        />
        Email
      </button>
      <button
        class="flex items-center h-6 px-3 text-sm rounded-full whitespace-nowrap transition-colors duration-150"
        :class="segClass(isNote())"
        @click="emit('setNote')"
      >
        {{ $t('CONVERSATION.REPLYBOX.PRIVATE_NOTE') }}
      </button>
    </div>
    <span
      v-if="windowLabel && channel === 'whatsapp' && !isNote()"
      class="flex items-center gap-1.5 text-xs text-n-slate-11 whitespace-nowrap flex-shrink-0"
      :title="'fenêtre WhatsApp · ' + windowLabel"
    >
      <span
        class="inline-block size-1.5 rounded-full flex-shrink-0"
        :class="
          windowLabel.includes('fermée') ? 'bg-n-ruby-9' : 'bg-[#25D366]'
        "
      />
      <b class="text-n-slate-12 font-semibold tabular-nums">{{
        windowLabel.includes('fermée') ? 'template requis' : windowLabel
      }}</b>
    </span>
  </div>
</template>
